// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Flight homepage search widget promo — desktop Figma 6780:59002, mobile Figma 6931:40497 */

.ConvenienceFeeHomepageSearchBanner_promoRow__Ntoag {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  min-width: 0;
  min-height: 34px;
}

.ConvenienceFeeHomepageSearchBanner_promoCopy__1fzCd {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.ConvenienceFeeHomepageSearchBanner_zeroImg__WVZgT {
  display: block;
  width: 31px;
  height: 24.739px;
  flex-shrink: 0;
  object-fit: contain;
}

.ConvenienceFeeHomepageSearchBanner_heroWrap__LVRkS {
  position: relative;
  flex: 0 0 69px;
  width: 69px;
  height: 58px;
  border-radius: 6px;
  overflow: hidden;
  flex-shrink: 0;
}

.ConvenienceFeeHomepageSearchBanner_heroImg__ocqWT {
  position: absolute;
  top: 0;
  left: -0.78%;
  width: 101.57%;
  height: 100%;
  max-width: none;
  object-fit: cover;
  display: block;
}

/* ── Desktop: Figma 6780:59002 ── */

.ConvenienceFeeHomepageSearchBanner_desktopBanner__HwtEb {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  margin-left: auto;
  flex-shrink: 0;
  width: auto;
  max-width: 100%;
  box-sizing: border-box;
  padding: 8px 0;
  border-radius: 16px;
  background: #fbfbfb;
}

/* Label/large-600 */
.ConvenienceFeeHomepageSearchBanner_desktopTitle__\\+DR2D {
  margin: 0;
  flex-shrink: 0;
  color: #1a1827;
  font-family: 'Host Grotesk', sans-serif;
  font-size: 14px;
  font-weight: 600;
  font-style: normal;
  line-height: 20px;
  letter-spacing: 0.2px;
  white-space: nowrap;
}

/* ── Mobile: Figma 6931:40497 ── */

.ConvenienceFeeHomepageSearchBanner_mobileBanner__vW4Dh {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
  margin-top: 12px;
  padding: 8px 0 8px 12px;
  border-radius: 16px;
  background: #fbfbfb;
  overflow: hidden;
}

/* Three-column row: fixed ₹0 | flex text | fixed hero (Figma 6931:40497) */
.ConvenienceFeeHomepageSearchBanner_mobileRow__H8KSC {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-width: 0;
  min-height: 34px;
}

/* Label/medium-500 — wraps on narrow screens; never overlaps hero */
.ConvenienceFeeHomepageSearchBanner_mobileTitle__LX0um {
  margin: 0;
  flex: 1 1 auto;
  min-width: 0;
  color: #1a1827;
  font-family: 'Host Grotesk', sans-serif;
  font-size: 12px;
  font-weight: 500;
  font-style: normal;
  line-height: 16px;
  letter-spacing: 0.25px;
}

.ConvenienceFeeHomepageSearchBanner_mobileHeroWrap__A0jqb {
  flex: 0 0 69px;
  width: 69px;
  height: 58px;
  flex-shrink: 0;
  align-self: center;
  overflow: hidden;
}

.ConvenienceFeeHomepageSearchBanner_mobileHero__T2KwK {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: right center;
}

@media (max-width: 899px) {
  .ConvenienceFeeHomepageSearchBanner_desktopBanner__HwtEb {
    display: none;
  }
}

@media (min-width: 900px) {
  .ConvenienceFeeHomepageSearchBanner_mobileBanner__vW4Dh {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/promo/convenienceFee/styles/ConvenienceFeeHomepageSearchBanner.module.css"],"names":[],"mappings":"AAAA,4FAA4F;;AAE5F;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,oCAAoC;;AAEpC;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,SAAS;EACT,cAAc;EACd,cAAc;EACd,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,mCAAmC;;AAEnC;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,2EAA2E;AAC3E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA,oEAAoE;AACpE;EACE,SAAS;EACT,cAAc;EACd,YAAY;EACZ,cAAc;EACd,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["/* Flight homepage search widget promo — desktop Figma 6780:59002, mobile Figma 6931:40497 */\n\n.promoRow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 24px;\n  min-width: 0;\n  min-height: 34px;\n}\n\n.promoCopy {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.zeroImg {\n  display: block;\n  width: 31px;\n  height: 24.739px;\n  flex-shrink: 0;\n  object-fit: contain;\n}\n\n.heroWrap {\n  position: relative;\n  flex: 0 0 69px;\n  width: 69px;\n  height: 58px;\n  border-radius: 6px;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.heroImg {\n  position: absolute;\n  top: 0;\n  left: -0.78%;\n  width: 101.57%;\n  height: 100%;\n  max-width: none;\n  object-fit: cover;\n  display: block;\n}\n\n/* ── Desktop: Figma 6780:59002 ── */\n\n.desktopBanner {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: center;\n  margin-left: auto;\n  flex-shrink: 0;\n  width: auto;\n  max-width: 100%;\n  box-sizing: border-box;\n  padding: 8px 0;\n  border-radius: 16px;\n  background: #fbfbfb;\n}\n\n/* Label/large-600 */\n.desktopTitle {\n  margin: 0;\n  flex-shrink: 0;\n  color: #1a1827;\n  font-family: 'Host Grotesk', sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  font-style: normal;\n  line-height: 20px;\n  letter-spacing: 0.2px;\n  white-space: nowrap;\n}\n\n/* ── Mobile: Figma 6931:40497 ── */\n\n.mobileBanner {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: center;\n  width: 100%;\n  box-sizing: border-box;\n  margin-top: 12px;\n  padding: 8px 0 8px 12px;\n  border-radius: 16px;\n  background: #fbfbfb;\n  overflow: hidden;\n}\n\n/* Three-column row: fixed ₹0 | flex text | fixed hero (Figma 6931:40497) */\n.mobileRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  min-width: 0;\n  min-height: 34px;\n}\n\n/* Label/medium-500 — wraps on narrow screens; never overlaps hero */\n.mobileTitle {\n  margin: 0;\n  flex: 1 1 auto;\n  min-width: 0;\n  color: #1a1827;\n  font-family: 'Host Grotesk', sans-serif;\n  font-size: 12px;\n  font-weight: 500;\n  font-style: normal;\n  line-height: 16px;\n  letter-spacing: 0.25px;\n}\n\n.mobileHeroWrap {\n  flex: 0 0 69px;\n  width: 69px;\n  height: 58px;\n  flex-shrink: 0;\n  align-self: center;\n  overflow: hidden;\n}\n\n.mobileHero {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: right center;\n}\n\n@media (max-width: 899px) {\n  .desktopBanner {\n    display: none;\n  }\n}\n\n@media (min-width: 900px) {\n  .mobileBanner {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"promoRow": `ConvenienceFeeHomepageSearchBanner_promoRow__Ntoag`,
	"promoCopy": `ConvenienceFeeHomepageSearchBanner_promoCopy__1fzCd`,
	"zeroImg": `ConvenienceFeeHomepageSearchBanner_zeroImg__WVZgT`,
	"heroWrap": `ConvenienceFeeHomepageSearchBanner_heroWrap__LVRkS`,
	"heroImg": `ConvenienceFeeHomepageSearchBanner_heroImg__ocqWT`,
	"desktopBanner": `ConvenienceFeeHomepageSearchBanner_desktopBanner__HwtEb`,
	"desktopTitle": `ConvenienceFeeHomepageSearchBanner_desktopTitle__+DR2D`,
	"mobileBanner": `ConvenienceFeeHomepageSearchBanner_mobileBanner__vW4Dh`,
	"mobileRow": `ConvenienceFeeHomepageSearchBanner_mobileRow__H8KSC`,
	"mobileTitle": `ConvenienceFeeHomepageSearchBanner_mobileTitle__LX0um`,
	"mobileHeroWrap": `ConvenienceFeeHomepageSearchBanner_mobileHeroWrap__A0jqb`,
	"mobileHero": `ConvenienceFeeHomepageSearchBanner_mobileHero__T2KwK`
};
export default ___CSS_LOADER_EXPORT___;
